import React, { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router'
import { Box, Flyout, FlyoutHeader } from '@deal/components'
import { IdentityContext } from '#src/containers/Identity'
import { LoggedInCart, GuestCart } from '#src/components/ShoppingCart'
import styles from './styles.css'

const Cart: React.FC = () => {
  const history = useHistory()
  const { myself } = useContext(IdentityContext)
  const [isMounted, setIsMounted] = useState(false)
  const onClose = () => history.replace({ ...location, hash: undefined })

  useEffect(() => {
    setIsMounted(true)
  }, [])

  /**
   * We never render the cart on SSR, be more explicit about that instead of
   * handling it in the open menu
   */
  if (!isMounted) {
    return null
  }

  return (
    <Flyout
      from="right"
      isOpen={history.location.hash === '#cart'}
      onClose={onClose}
      data-testid="cart-overlay"
      width="small"
    >
      <FlyoutHeader title="Your cart" onClose={onClose} />
      <Box.Item className={styles.cartContainer} grow={1}>
        {myself ? <LoggedInCart /> : <GuestCart />}
      </Box.Item>
    </Flyout>
  )
}
export default Cart
